export default __webpack_public_path__ + "static/media/leftMan.42203ca4.png";